export default {
  name: 'zh-cn',
  data: {
    modal: {
      cancel: '取消',
      confirm: '确认'
    },
    pagination: {
      prev: '上一页',
      next: '下一页'
    },
    select: {
      empty: '暂无数据... \\[ o_x ]/'
    },
    table: {
      empty: '暂无数据... \\[ o_x ]/'
    }
  }
}